// نقرة الحضور/الانصراف — منطق واحد يستعمله زرّا الصفحة وزرّ الترويسة معًا.
//
// استُخرج من TapButtons كما هو حرفيًا ليُستعمل من مكانين بلا **نسخة ثانية** من قواعد الحضور:
// المسار نفسه، والجسم نفسه (الموقع لحظة النقرة وحده — لا وقت ولا معرّف موظف ولا بيانات جهاز)،
// والوقت من الخادم لا من الجهاز، ورفض إذن الموقع لا يمنع التسجيل (`tapLocation` لا ترفض أبدًا).
import { useState } from 'react';
import { ApiError, post, type AttendanceEvent, type AttendanceKind } from '../lib/api.ts';
import { tapLocation } from './geo.ts';

const PATH: Record<AttendanceKind, string> = {
  CHECK_IN: '/attendance/check-in',
  CHECK_OUT: '/attendance/check-out',
};

export interface TapState {
  /** أي نقرة قيد التنفيذ الآن — كل زرّ يُعطَّل أثناء طلبه **وحده**، لا لفرض ترتيب بين الزرّين. */
  busy: AttendanceKind | null;
  error: string | null;
  /** `lateNotice`: «اتأخرت كذا» يقوله الخادم لحظة الحضور (قرار المالك 02/10/2026) */
  done: { kind: AttendanceKind; at: string; lateNotice?: string | null } | null;
  tap: (kind: AttendanceKind) => Promise<void>;
}

export function useTap(onRecorded: () => void | Promise<void>): TapState {
  const [busy, setBusy] = useState<AttendanceKind | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState<{ kind: AttendanceKind; at: string; lateNotice?: string | null } | null>(null);

  async function tap(kind: AttendanceKind): Promise<void> {
    setBusy(kind); setError(null); setDone(null);
    try {
      const body = await tapLocation();
      const ev = await post<AttendanceEvent & { lateNotice?: string | null }>(PATH[kind], body);
      setDone({ kind, at: ev.occurredAt, lateNotice: ev.lateNotice ?? null });
      await onRecorded();
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'تعذّر تسجيل العملية — حاول مرة أخرى');
    } finally {
      setBusy(null);
    }
  }

  return { busy, error, done, tap };
}
